// src/components/atoms/tooltip-text/tooltip-text.tsx

import { InformationCircleIcon } from '@heroicons/react/24/outline';
import { Typography } from '@material-tailwind/react';
import { Tooltip } from '@mui/material';

interface TextTooltipProps {
  content: string;
  tooltipContent: string;
  placement?:
    | 'bottom-end'
    | 'bottom-start'
    | 'bottom'
    | 'left-end'
    | 'left-start'
    | 'left'
    | 'right-end'
    | 'right-start'
    | 'right'
    | 'top-end'
    | 'top-start'
    | 'top';
  iconClassName?: string;
}

const TextTooltip: React.FC<TextTooltipProps> = ({
  content,
  tooltipContent,
  placement = 'top',
  iconClassName = '',
}) => {
  const iconClasses = `font-normal text-sm ${iconClassName}`;
  return (
    <div className="flex flex-row">
      <Typography className={iconClasses}>{content}</Typography>
      <Tooltip
        title={tooltipContent}
        placement={placement}
        className="text-gray-600 ml-1"
        PopperProps={{
          // workaround to avoid tooltip being hidden behind modals
          style: { zIndex: 10000 },
        }}
      >
        <InformationCircleIcon className="h-4 w-4 mt-0.5" />
      </Tooltip>
    </div>
  );
};

export default TextTooltip;
